import { getDotPath, safeParseAsync, } from 'valibot';
/**
 * Creates a validation functions that parses the Valibot schema of a form.
 *
 * @param schema A Valibot schema.
 *
 * @returns A validation function.
 */
export function valiForm(schema) {
    return async (values) => {
        const result = await safeParseAsync(schema, values, {
            abortPipeEarly: true,
        });
        const formErrors = {};
        if (result.issues) {
            for (const issue of result.issues) {
                formErrors[getDotPath(issue)] = issue.message;
            }
        }
        return formErrors;
    };
}
